module.exports = __webpack_public_path__ + "img/coupon_198_100.2fb3b338.png";